export const policySubMenu = [{
  path: '/policies/list',
  component: () => import('@/views/policies/list.vue'),
  name: 'schemeManagement.policy.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Regional Manager', 'Zonal Manager'],
    title: 'schemeManagement.policy.title',
    noCache: true,
    icon: 'auction'
  }
}, {
  path: '/policies/edit/:id(\\d+)',
  component: () => import('@/views/policies/manage.vue'),
  name: 'schemeManagement.policy.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'schemeManagement.policy.edit',
    noCache: true,
    activeMenu: '/policies/list',
    hidden: true
  }
}, {
  path: '/policies/add/',
  component: () => import('@/views/policies/manage.vue'),
  name: 'schemeManagement.policy.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.policy.add',
    noCache: true,
    activeMenu: '/policies/list',
    hidden: true
  }
}, {
  path: '/policies/import',
  component: () => import('@/views/policies/import.vue'),
  name: 'schemeManagement.policy.import',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.policy.import',
    noCache: true,
    hidden: true
  }
}];